<p>lvms-booking-create works!</p>
<div [formGroup]="bookingForm" *ngIf="bookingForm">
    <input formControlName="searchTerm">
    <select formControlName="country">
        <option [ngValue]="country" *ngFor="let country of countries | jsonFilter:[bookingForm.value.searchTerm, 'name']">{{country.name}}</option>
    </select>
</div>

